import { connect } from 'react-redux';
import { get, has, isEmpty, groupBy } from 'lodash/fp';
import {
  fetchInventoryTagOptions,
  fetchInventoryPackageItems,
  fetchInventoryLocationOptions,
  fetchInventoryLocationZoneOptions,
  fetchInventoryPackageActiveReservationOrderItemsCount
} from '../../../redux/sagas/routines';
import {
  getIsSaving as getIsSavingItem,
  getIsSaved as getIsItemSaved
} from '../../../redux/Inventory/selectors/item';
import {
  getIsSaving as getIsSavingPackage,
  getIsSaved as getIsPackageSaved
} from '../../../redux/Inventory/selectors/package';
import {
  getTagOptions,
  getItemOptions,
  getFormPackageItems,
  getIsFetchingPackageItems,
  getIsFetchedPackageItems,
  getPackageActiveReservationOrderItemsCount
} from '../../../redux/Inventory/selectors/components/item-form';
import {
  getLocationOptions,
  getLocationZoneOptions
} from '../../../redux/Inventory/selectors/components/adjust-item-form';
import {
  resetFormPackageItems,
  addInventoryPackageItem,
  deleteInventoryPackageItem,
  undoDeleteInventoryPackageItem,
  incrementQtyInventoryPackageItem,
  decrementQtyInventoryPackageItem,
  clearPackageItems,
  clearPackageActiveReservationOrderItemsCount
} from '../../../redux/Inventory/actions';
import { PackageType } from '../../../constants/inventory/InventoryTypes';
import InventoryItemForm from '../../../components/inventory/ItemForm';

function mapStateToProps(state, { item, type }) {
  const isEdit = !isEmpty(item) && has('id', item);
  const isPackage = type === PackageType;
  return {
    type,
    tagOptions: getTagOptions(state),
    itemOptions: getItemOptions(state),
    locationOptions: isPackage ? getLocationOptions(state) : [],
    zonesByLocationOptions: isPackage
      ? groupBy('locationId', getLocationZoneOptions(state))
      : {},
    packageItems: isPackage ? getFormPackageItems(state) : [],
    packageActiveReservationOrderItemsCount: getPackageActiveReservationOrderItemsCount(
      state
    ),
    isSaving: isPackage ? getIsSavingPackage(state) : getIsSavingItem(state),
    isSaved: isPackage ? getIsPackageSaved(state) : getIsItemSaved(state),
    isFetchingPackageItems:
      isPackage && isEdit && getIsFetchingPackageItems(state),
    isFetchedPackageItems:
      isPackage && isEdit && getIsFetchedPackageItems(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onInit: (item, type) => {
      const id = get('id', item);
      dispatch(fetchInventoryTagOptions());
      if (type === PackageType) {
        dispatch(fetchInventoryLocationOptions());
        dispatch(fetchInventoryLocationZoneOptions());
        if (item) {
          dispatch(fetchInventoryPackageItems(id));
          dispatch(fetchInventoryPackageActiveReservationOrderItemsCount(id));
        } else {
          dispatch(clearPackageItems());
          dispatch(clearPackageActiveReservationOrderItemsCount());
        }
      }
    },
    onResetPackageItems: () => {
      dispatch(resetFormPackageItems());
    },
    onAddPackageItem: packageItem => {
      const id = `new_${packageItem.item.id}`;
      dispatch(addInventoryPackageItem({ ...packageItem, id }));
    },
    onDeletePackageItem: packageItem => {
      dispatch(deleteInventoryPackageItem(packageItem));
    },
    onUndoDeletePackageItem: packageItem => {
      dispatch(undoDeleteInventoryPackageItem(packageItem));
    },
    onIncrementQtyPackageItem: packageItem => {
      dispatch(incrementQtyInventoryPackageItem(packageItem));
    },
    onDecrementQtyPackageItem: packageItem => {
      dispatch(decrementQtyInventoryPackageItem(packageItem));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InventoryItemForm);
